import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
const Vision = () => {
  useEffect(() => {
    document.title = "Vision -  St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> About Us </li>
          <li>Vision </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Vision </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 visionsec">
              <div className="quotes">
                <p>
                  <b>
                    ​A Centre of excellence exploring new frontiers in the realm
                    of education for nation-building.
                  </b>
                </p>
              </div>
              <img
                src="https://webapi.entab.info/api/image/STPSFH/public/Images/vision.jpeg"
                className="img-fluid mx-auto d-block img-small"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Vision;
